import { render } from "./ImmersiveBackLink.vue?vue&type=template&id=17dfb747&scoped=true"
import script from "./ImmersiveBackLink.vue?vue&type=script&lang=js"
export * from "./ImmersiveBackLink.vue?vue&type=script&lang=js"

import "./ImmersiveBackLink.vue?vue&type=style&index=0&id=17dfb747&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17dfb747"]])

export default __exports__